import styled from 'styled-components'

import EquationCross from 'components/core/icons/factory/EquationCross'
import EquationEquals from 'components/core/icons/factory/EquationEquals'
import EquationRoot from 'components/core/icons/factory/EquationRoot'
import EquationRootTail from 'components/core/icons/factory/EquationRootTail'
import { device } from 'components/draw/constants'

const GooRightDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-weight: 500;
  font-size: 24px;

  margin-top: 36px;
  @media ${device.laptopMax} {
    margin: 32px 0;
    flex-direction: column;
    gap: 24px;
  }
`

const GooEquationContainer = styled.div`
  display: flex;
  position: relative;
`

const EquationRootContainer = styled.div`
  position: absolute;
  pointer-events: none;
  left: 0;
  width: 100%;
  overflow: hidden;

  path {
    stroke: white;
  }
`

const EquationRootTailConatiner = styled.div`
  position: absolute;
  pointer-events: none;
  right: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  path {
    stroke: white;
  }
`

const EquationLeft = styled.div`
  margin-left: 36px;
  margin-top: 10px;

  @media ${device.laptopMax} {
    margin-left: 28px;
  }
`

const EquationRight = styled.div`
  margin-right: 10px;
  margin-top: 10px;
`

const EquationCrossContainer = styled.div`
  margin-top: 12px;
  margin-left: 16px;
  margin-right: 16px;

  path {
    fill: white;
  }

  @media ${device.laptopMax} {
    margin-left: 10px;
    margin-right: 10px;
  }
`

const EquationEqualsContainer = styled.div`
  path {
    fill: white;
  }
  margin: 0 16px;

  filter: drop-shadow(0px 0px 12px rgba(255, 255, 255, 0.64));
`

const EquationTotal = styled.div`
  font-size: 28px;
  background-color: white;
  color: black;
  font-weight: 700;
  padding: 12px 24px;
  border-radius: 12px;
`

const GooBottomRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

function GooPlaceholderEquation() {
  return (
    <GooRightDetails>
      <GooEquationContainer>
        <EquationLeft>
          <div>Goo staked</div>
        </EquationLeft>
        <EquationCrossContainer>
          <EquationCross />
        </EquationCrossContainer>
        <EquationRight>
          <div>Multiplier</div>
        </EquationRight>
        <EquationRootContainer>
          <EquationRoot />
        </EquationRootContainer>
        <EquationRootTailConatiner>
          <EquationRootTail />
        </EquationRootTailConatiner>
      </GooEquationContainer>
      <GooBottomRightContainer>
        <EquationEqualsContainer>
          <EquationEquals />
        </EquationEqualsContainer>
        <EquationTotal>Daily Goo</EquationTotal>
      </GooBottomRightContainer>
    </GooRightDetails>
  )
}

export default GooPlaceholderEquation
